import { Panel } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

import { LANDSCAPE_TOOLBAR_WIDTH } from 'src/modules/designStudio/components/Toolbar/toolBarConstants';
import { useToolbarDisplaySettings } from 'src/modules/designStudio/hooks';
import { useIsLandscape } from 'src/shared/hooks';

const ScrollContainer = ({ children }: { children?: ReactNode }) => {
  const [isLandscape] = useIsLandscape();
  const { shouldCenterToolbar } = useToolbarDisplaySettings();

  return (
    <Panel
      alignContent="flex-end"
      alignItems={isLandscape ? 'center' : 'flex-start'}
      borderRadius={isLandscape ? 0 : 300}
      borderRightColor={isLandscape ? 'neutral200' : undefined}
      borderRightStyle={isLandscape ? 'solid' : undefined}
      borderRightWidth={isLandscape ? '0.5px' : undefined}
      height="100%"
      justifyContent={isLandscape ? 'center' : undefined}
      marginX={0}
      overflowX={isLandscape ? 'hidden' : 'auto'}
      padding={0}
      sx={{
        '-ms-overflow-style': 'none' /* for Internet Explorer, Edge */,
        'scrollbar-width': 'none' /* for Firefox */,

        '&::-webkit-scrollbar': {
          display: 'none' /* for Chrome, Safari, and Opera */,
        },
      }}
      // eslint-disable-next-line
      width={isLandscape ? LANDSCAPE_TOOLBAR_WIDTH : undefined}
      zIndex="popover"
    >
      <Panel
        flexDirection={isLandscape ? 'column' : 'row'}
        overflowX={isLandscape ? 'hidden' : 'auto'}
        overflowY={isLandscape ? 'auto' : 'hidden'}
        padding={0}
        width={isLandscape ? LANDSCAPE_TOOLBAR_WIDTH : undefined}
      >
        <Panel
          alignContent="flex-end"
          borderRadius={0}
          flexDirection={isLandscape ? 'column' : 'row'}
          height={isLandscape ? undefined : 500}
          justifyContent={shouldCenterToolbar ? 'space-evenly' : undefined}
          marginRight={shouldCenterToolbar ? undefined : 100}
          padding={0}
          width={shouldCenterToolbar ? '100vw' : undefined}
        >
          {children}
        </Panel>
      </Panel>
    </Panel>
  );
};

export { ScrollContainer };
